// extracted by mini-css-extract-plugin
module.exports = {"container":"comments-empty_container__3k4Qd","title":"comments-empty_title__y1lNa","description":"comments-empty_description__1YIuw"};